import React from 'react'
import FormatNumber from '@i18n/formatNumber/Component'

import Quantity from './Quantity'

import styles from './styles.module.css'

export default function Tip(props) {
  const {
    deliveryType,
    cart: {bagAmount}
  } = props.preferences

  const renderLine = (label, value, style?) => (
    <div className={style || styles.line}>
      <div className={styles.label}>{label}</div>
      <div>{value}</div>
    </div>
  )

  if (!bagAmount) return null
  if (deliveryType !== 'go') return renderLine('Bolsas', <FormatNumber value={bagAmount} />)

  return (
    <div className={styles.container}>
      <div className={styles.head}>
        <div className={styles.quantity}>
          <Quantity preferences={props.preferences} />
        </div>
        <div className={styles.name}>Bolsas</div>

        <div>{<FormatNumber value={bagAmount} />}</div>
      </div>
    </div>
  )
}
